// @flow

import React from 'react';
import { get } from 'lodash';

import { AppOverview } from '@zapier/design-system-app-profiles';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import WithHashValue from 'web-ssr/app/common/components/WithHashValue';
import appOverviewQuery from 'web-ssr/app/app-directory/components/AppOverview/appOverviewQuery';
import { addProtocolToUrl } from 'web-ssr/app/common/utils/UrlUtils';
import { isPartnerSilverOrMore } from 'web-ssr/app/partners/utils';

import type {
  appOverviewQuery as appOverviewQueryType,
  appOverviewQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: appOverviewQueryType,
};

type Props = {
  primaryAppSlug: string,
};

const AppOverviewContainer = (props: Props) => {
  const variables: appOverviewQueryVariables = { slug: props.primaryAppSlug };

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { mode: 'mobile' },
    [Screen.queries.phablet]: { mode: 'mobile' },
    [Screen.queries.tablet]: { mode: 'header' },
    [Screen.queries.desktop]: { mode: 'sidebar' },
  });

  return (
    <WithHashValue hashKey="show-app-details">
      {value => {
        return (
          <ApolloQuery query={appOverviewQuery} variables={variables}>
            {(result: Result) => {
              const { appBySlug } = result.data || {};

              if (!appBySlug) {
                return null;
              }

              const isDetailsVisible = Boolean(value) === true;

              const isTopTierPartner = isPartnerSilverOrMore(
                get(appBySlug, ['partnerStatus', 'tier'])
              );
              const learnMoreHref =
                appBySlug.learnMoreUrl &&
                addProtocolToUrl(appBySlug.learnMoreUrl, 'https://');

              return (
                <AppOverview
                  backHref="#"
                  categories={appBySlug.categories.map(
                    category => category.name
                  )}
                  color={`#${appBySlug.primaryColor || 'efefef'}`}
                  description={appBySlug.description}
                  detailsHref="#show-app-details=true"
                  iconSrc={appBySlug.image || ''}
                  isDetailsVisible={isDetailsVisible}
                  isTopTierPartner={isTopTierPartner}
                  learnMoreHref={learnMoreHref}
                  mode={layoutProps.mode}
                  name={appBySlug.name}
                />
              );
            }}
          </ApolloQuery>
        );
      }}
    </WithHashValue>
  );
};

export default AppOverviewContainer;
